import React from "react";

// Style \\
import "../../assets/styles/sections/contactForm.scss";

const ContactForm = () => {
  return (
    <section className="contactForm">
      <div className="containers">
        <div className="contactForm_items">
          <div className="title text-center">
            <h3>Contact Us</h3>
            <p className="w-2/4 text-center mx-auto my-2 text-xl">
              Lorem ipsum dolor sit amet consectetur adipisicing elit.
              Laudantium, sint.
            </p>
          </div>

          <div className="form_box border border-red-900 flex items-center gap-6">
            <div className="content w-2/4 pl-20">
              <h4 className="formTitle">Fill out the form!</h4>
              <p className="mt-3 text-lg">
                Check out the comments for line by line explanations.
                Form-related code starts on line 145.
              </p>
            </div>
            <form action="" className="form py-9 ">
              <input
                type="text"
                placeholder="Name"
                className="form__input"
                id="name"
              />
              <label for="name" className="form__label">
                Name
              </label>

              <input
                type="email"
                placeholder="Email"
                className="form__input"
                id="email"
              />
              <label for="email" className="form__label">
                Email
              </label>

              <input
                type="text"
                placeholder="Subject"
                className="form__input"
                id="subject"
              />
              <label for="subject" className="form__label">
                Subject
              </label>

              <button className="submitBtn">Submit</button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactForm;
